import { INFINITY_HOST } from '../common/consts/playerSearchParams';

/**
 * Whether the player URL carries the 720 free-content embed signal. Accepts the raw `slxapi` launch
 * param OR the benign `host=infinity` marker — so the signal keeps working once `slxapi` is stripped
 * from the URL after the content-session exchange. Never keys on `businessDomain` (the server stays
 * authoritative on access).
 */
export const isFreeContentEmbedSignal = (search: { slxapi?: unknown; host?: unknown } | undefined): boolean =>
  search?.slxapi != null || search?.host === INFINITY_HOST;
